import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
//import ListingsScreen from "../screens/ListingsScreen";
import ListingDetailsScreen from "../screens/ListingDetailsScreen";
import UserFixoScreen from "../screens/UserFixoScreen";
import AccountScreen from "../screens/AccountScreen";
import MessagesScreen from "../screens/MessagesScreen";
import CommentsPublicationScreen from "../screens/CommentsPublicationScreen";
import ChatUserListScreen from "../screens/ChatUserListScreen";
import ChatScreen from "../screens/ChatScreen";
import FeedScreen from "../screens/FeedScreen";
import ListingDetailsSeedScreen from "../screens/ListingDetailsSeedScreen";
import SearchSeedScreen from "../screens/SearchSeedScreen";
import FollowersScreen from "../screens/FollowersScreen";
import FollowedScreen from "../screens/FollowedScreen";
import ListingsSeedsScreen from "../screens/ListingsSeedsScreen";
import HistoryDetailScreen from "../screens/HistoryDetailScreen";
import HistoryScreen from "../screens/HistoryScreen";
import SearchUserScreen from "../screens/SearchUserScreen";
import ImageVisor from "../components/ImageVisor";
import ViewImageScreen from "../screens/ViewImageScreen";
import RecPaswordScreen from "../screens/RecPasswordScreen";
import QuienesSomosScreen from "../screens/QuienesSomosScreen";


const Stack = createStackNavigator();

const FeedNavigator = () => {
  return (
    // <Stack.Navigator mode="modal" screenOptions={{ headerShown: false }}>
    <Stack.Navigator  >
      <Stack.Screen name="Feed" component={FeedScreen} options={{ headerShown: false }} />
      <Stack.Screen name="Quienes Somos" component={QuienesSomosScreen} options={{ headerShown: false }} />
      <Stack.Screen name="recPassword" component={RecPaswordScreen} options={{ headerShown: false }} />
      <Stack.Screen name="Chat List" component={ChatUserListScreen} options={{ title: 'charliños',  headerStyle: { backgroundColor: 'papayawhip'}  }}/>
      <Stack.Screen name="Chat" component={ChatScreen} options={{ headerShown: false }}/>
      <Stack.Screen name="Account" component={AccountScreen} />
      <Stack.Screen name="Messages" component={MessagesScreen} />
      <Stack.Screen name="CommentsPublication" component={CommentsPublicationScreen} />
      <Stack.Screen name="ListingDetails" component={ListingDetailsScreen} />
      <Stack.Screen name="Seed Details" component={ListingDetailsSeedScreen} options={{ headerShown: false, tabBarVisible: false }} />
      <Stack.Screen name="Search Seed" component={SearchSeedScreen} options={{ tabBarVisible: false }} />
      <Stack.Screen name="User Fixo" component={UserFixoScreen} />
      <Stack.Screen name="Followers" component={FollowersScreen} />
      <Stack.Screen name="Followed" component={FollowedScreen} />
      <Stack.Screen name="Listings Seed" component={ListingsSeedsScreen} />
      <Stack.Screen name="Historia" component={HistoryDetailScreen} />
      <Stack.Screen name="Historias" component={HistoryScreen} />
      <Stack.Screen name="Search" component={SearchUserScreen} />
      <Stack.Screen name="Imagen" component={ImageVisor} />
      <Stack.Screen 
       name="ViewImage"
       component={ViewImageScreen} 
       options={{ 
                title:'Regresar',
                tabBarVisible: false, 
                //headerShown: false
              }}
      />


    </Stack.Navigator>
  )
}

export default FeedNavigator;
